import type { Message, Conversation } from '../types';

export const initialMessages: Message[] = [
  {
    id: 1,
    sender: "Chance Botosh",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    time: "04:55 PM",
    content: "Salut, j'ai remarqué qu'il y a un problème avec l'emplacement du bouton sur la nouvelle fonctionnalité. Ça semble un peu décalé, et je ne suis pas sûr si c'est intentionnel.",
    isCurrentUser: true
  },
  {
    id: 2,
    sender: "Support Team",
    time: "04:56 PM",
    content: "Salut Chance ! Merci de l'avoir mentionné. Laisse-moi jeter un œil. Pourrais-tu préciser sur quelle page et quelle section tu fais référence ?",
    isCurrentUser: false
  }
];

export const initialConversations: Conversation[] = [
  {
    id: 1,
    name: "Chance Botosh",
    role: "Designer principal de produits",
    time: "8:15 AM",
    active: true,
    isPinned: true,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
  },
  {
    id: 2,
    name: "Thérèse Webb",
    message: "Vous: Pouvez-vous s'il vous plaît...",
    time: "8:12 AM",
    isPinned: true,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
  },
  {
    id: 3,
    name: "Randy Westervelt",
    message: "Vous: Pouvez-vous me dire...",
    time: "8:10 AM",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
  }
];